<template><div class="loginer">
    <div class="bgheadeimg"><img :src="bgimg"></div>

    <div class="newclasswindow shadow">
        <div class="title" style="margin-top: 20px;text-align: center;">
            <h2 style="font-size: 30px;color: #ff9900;">{{page_title}}</h2>
            <div class="subtitle" style="font-size: 20px;color: #333;">{{page_subtitle}}</div>
        </div>
        
    	<Form class="logform" ref="frmdata" :model="frmdata" :rules="rulers">
            <FormItem prop="account">
                <Input size="large" type="text" v-model="frmdata.account" placeholder="管理账号" @on-enter="onSubmit('frmdata')" autofocus>
                    <i class="iconfont icon-user" slot="prepend"></i>
                </Input>
            </FormItem>
            <FormItem prop="password">
                <Input size="large" type="password" v-model="frmdata.password" placeholder="输入密码" @on-enter="onSubmit('frmdata')">
                    <i class="iconfont icon-3701mima" slot="prepend"></i>
                </Input>
            </FormItem>
            <FormItem style="margin:0;">
                <Button size="large" long type="primary" @click="onSubmit('frmdata')">登 录</Button>
            </FormItem>
        </Form>
    </div>
</div></template>

<script>
import jGlobal from '@/global';

export default
{
	name: 'login',
	data (){
		return {
            page_title: '',
            page_subtitle: '',
			frmdata: {
                account: '',
                password: ''
            },
            rulers: {
                account: [
                    {"required": true,"message": '请输入管理账号',"trigger": 'blur'}
                ],
                password: [
                    {"required": true,"message": '请输入密码',"trigger": 'blur'},
                    {"type": 'string',"min": 5,"message": '密码长度不能少于5位',"trigger": 'blur'}
                ],
            },
            bgimg: '',
		}
	},
    created (){
        this.page_title = window.page_title || '';
        this.page_subtitle = window.page_subtitle || '';
        this.bgimg = window.hosturl + 'image/loginbg.jpg';
        this.$nextTick(() => {
            let that = this;
            $(window).on("resize", function(e){
                let winh = $(this).height(), winw = $(this).width();
                $(that.$el).width(winw).height(winh)
            }).trigger("resize")
        })
    },
	methods: {
        onSubmit(idx) {
            this.$refs[idx].validate(valid => {
                if (! valid) return false;
                jGlobal.xhrPost('user/login', this.frmdata, res => {
                    if (res.result == 'OK') {
                        let _query = '', srharr = jGlobal.parSearch();
                        if (srharr.sicode) delete srharr.sicode;
                        this.$cookie.set('loginresponsid', res.sid);
                        if (! Object.keys(srharr).length){location.reload();return false}
                        for (let ky in srharr) _query += `&${ky}=${srharr[ky]}`;
                        location.search = _query.substr(1)
                    } else this.$Message.error(res.data.errmsg)
                }, err => this.$Message.error(err))
            })
        },
    },
}
</script>

<style scoped>
.newclasswindow {width: 500px;height: 400px;border-radius: 10px;background: #ffffff;}
.loginer {display: flex;justify-content: center;}
.shadow {position: relative;box-shadow: 0px 1px -1px rgba(0,0,0,0.3),0px 0px 20px rgba(0,0,0,0.1) inset;top:150px;}
.shadow::before,.shadow::after {content:""; position:absolute;z-index:-1;bottom:15px;left:10px;width:50%;height:20%;}
.shadow::before,.shadow::after {content: "";position: absolute;z-index: -1;bottom: 15px;left: 10px;width: 66%; height: 25%;box-shadow: 4px 21px 12px rgba(0, 0, 0, 0.4);transform: rotate(-3deg);}
.ivu-form-item {margin-bottom: 44px!important;}
.shadow::after {right:10px;left:auto;transform:rotate(3deg);}
.bgheadeimg {width: 100%;height: 470px;position: absolute;}
.bgheadeimg img {width: 100%;height:470px;}
.ivu-btn-primary {background: #ff9f17;font-size: 15px;color: #ffffff;border-color:#ff9f17;}
.logform {margin: 40px auto 0;width: 450px;}
</style>


// WEBPACK FOOTER //
// login.vue?f8c41454